import { FC, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/_atoms/command";

import { FilterDisplayView } from "./filter-display-view";

export interface FilterCommandConfiguration {
  id: string;
  displayValue: string;
  displayView: ReactElement;
  configurationView?: ReactElement | null;
  configurationViewType: "none" | "popover" | "modal";
}

export interface FilterCommandViewProps {
  filterList: FilterCommandConfiguration[];
  onSelect: (filter: FilterCommandConfiguration) => void;
}

export const FilterCommandView: FC<FilterCommandViewProps> = ({ filterList, onSelect }) => {
  const { t } = useTranslation("common");
  return (
    <Command data-testid="filter-command-view">
      <CommandInput placeholder={t("view.filterPlaceholder")} />
      <CommandList>
        <CommandEmpty>{t("search.noResults")}</CommandEmpty>
        <CommandGroup>
          {filterList.map((filter) => (
            <CommandItem key={filter.id} value={filter.displayValue} onSelect={() => onSelect(filter)} className="p-0">
              <FilterDisplayView>{filter.displayView}</FilterDisplayView>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
};
